// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var $$Array = require("rescript/lib/js/array.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Css_Legacy_Core = require("bs-css/src/Css_Legacy_Core.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var RenderOnHost__Notification__JumpToTabOutput$SmartcutsMacros = require("./RenderOnHost__Notification__JumpToTabOutput.bs.js");

var t_encode = Decco.stringToJson;

var t_decode = Decco.stringFromJson;

function stringify(s) {
  return s;
}

var container = CssJs.style([
      CssJs.backgroundColor(CssJs.hex("00cae3")),
      CssJs.height(CssJs.px(140)),
      CssJs.padding({
            NAME: "rem",
            VAL: 1.5
          }),
      CssJs.fontSize({
            NAME: "rem",
            VAL: 1
          }),
      CssJs.lineHeight({
            NAME: "abs",
            VAL: 1.75
          }),
      CssJs.fontWeight({
            NAME: "num",
            VAL: 400
          }),
      CssJs.color(CssJs.hex("fff"))
    ]);

var Style = {
  container: container
};

function RenderOnHost__Notification$TextOutput(Props) {
  var textOutput = Props.textOutput;
  return React.createElement("div", {
              className: container
            }, textOutput);
}

var TextOutput = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  Style: Style,
  make: RenderOnHost__Notification$TextOutput
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "text",
                Decco.stringToJson(v.text)
              ],
              [
                "href",
                Decco.stringToJson(v.href)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
    if (href.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                href: href._0
              }
            };
    }
    var e = href._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".href" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Link = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "template",
                Decco.stringToJson(v.template)
              ],
              [
                "link",
                t_encode$1(v.link)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var template = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "template"), null));
  if (template.TAG === /* Ok */0) {
    var link = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
    if (link.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                template: template._0,
                link: link._0
              }
            };
    }
    var e = link._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".link" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = template._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".template" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(param) {
  return Util$SmartcutsMacros.compose((function (prim) {
                return JSON.stringify(prim);
              }), (function (prim) {
                return prim;
              }), param);
}

var container$1 = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex("55b559")),
      tl: {
        hd: Css.height(Css.px(140)),
        tl: {
          hd: Css.padding({
                NAME: "rem",
                VAL: 1.5
              }),
          tl: {
            hd: Css.fontSize({
                  NAME: "rem",
                  VAL: 1
                }),
            tl: {
              hd: Css.lineHeight({
                    NAME: "abs",
                    VAL: 1.75
                  }),
              tl: {
                hd: Css.fontWeight({
                      NAME: "num",
                      VAL: 400
                    }),
                tl: {
                  hd: Css.color(Css.hex("fff")),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var buttonToSpreadsheet = Curry._1(Css.style, {
      hd: Css.color(Css.hex("1A8FE6")),
      tl: {
        hd: Css.cursor("pointer"),
        tl: {
          hd: Css.margin("zero"),
          tl: {
            hd: Css.marginTop(Css.px(10)),
            tl: {
              hd: Css.outlineWidth("zero"),
              tl: {
                hd: Css.lineHeight({
                      NAME: "abs",
                      VAL: 1.499
                    }),
                tl: {
                  hd: Css.display("inlineBlock"),
                  tl: {
                    hd: Css.fontWeight({
                          NAME: "num",
                          VAL: 400
                        }),
                    tl: {
                      hd: Css.textAlign("center"),
                      tl: {
                        hd: Css.border(Css.px(1), "solid", "transparent"),
                        tl: {
                          hd: Css.boxShadow(Css_Legacy_Core.Shadow.box({
                                    NAME: "px",
                                    VAL: 0
                                  }, {
                                    NAME: "px",
                                    VAL: 2
                                  }, {
                                    NAME: "px",
                                    VAL: 0
                                  }, {
                                    NAME: "px",
                                    VAL: 0
                                  }, undefined, Css.rgba(173, 0, 0, {
                                        NAME: "num",
                                        VAL: 0.015
                                      }))),
                          tl: {
                            hd: Css.height(Css.px(32)),
                            tl: {
                              hd: Css.padding2("zero", Css.px(15)),
                              tl: {
                                hd: Css.fontSize(Css.px(14)),
                                tl: {
                                  hd: Css.borderRadius(Css.px(4)),
                                  tl: {
                                    hd: Css.backgroundColor(Css.hex("fff")),
                                    tl: {
                                      hd: Css.borderColor(Css.hex("d9d9d9")),
                                      tl: {
                                        hd: Css.textDecoration("none"),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Style$1 = {
  container: container$1,
  buttonToSpreadsheet: buttonToSpreadsheet
};

function RenderOnHost__Notification$UrlOutput(Props) {
  var param = Props.urlOutput;
  var match = param.link;
  var href = match.href;
  var text = match.text;
  var match$1 = $$Array.to_list(param.template.split("$link"));
  if (!match$1) {
    return null;
  }
  var match$2 = match$1.tl;
  var onlyText = match$1.hd;
  if (!match$2) {
    return React.createElement("div", {
                className: container$1
              }, onlyText);
  }
  var suffix = match$2.hd;
  if (suffix === "") {
    if (match$2.tl) {
      return null;
    } else {
      return React.createElement("div", {
                  className: container$1
                }, onlyText, React.createElement("button", {
                      className: buttonToSpreadsheet,
                      onClick: (function (param) {
                          window.open(href, "_blank", undefined);
                          
                        })
                    }, text));
    }
  } else if (match$2.tl) {
    return null;
  } else {
    return React.createElement("div", {
                className: container$1
              }, onlyText, React.createElement("button", {
                    className: buttonToSpreadsheet,
                    onClick: (function (param) {
                        window.open(href, "_blank", undefined);
                        
                      })
                  }, text), suffix);
  }
}

var UrlOutput = {
  Link: Link,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$1,
  Style: Style$1,
  make: RenderOnHost__Notification$UrlOutput
};

function t_encode$3(v) {
  switch (v.TAG | 0) {
    case /* TextOutput */0 :
        return [
                "TextOutput",
                Decco.stringToJson(v._0)
              ];
    case /* UrlOutput */1 :
        return [
                "UrlOutput",
                t_encode$2(v._0)
              ];
    case /* JumpToTabOutput */2 :
        return [
                "JumpToTabOutput",
                RenderOnHost__Notification__JumpToTabOutput$SmartcutsMacros.t_encode(v._0)
              ];
    
  }
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "JumpToTabOutput" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = RenderOnHost__Notification__JumpToTabOutput$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* JumpToTabOutput */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TextOutput" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextOutput */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "UrlOutput" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UrlOutput */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$2(v) {
  switch (v.TAG | 0) {
    case /* TextOutput */0 :
        return "TextOutput(" + (v._0 + ")");
    case /* UrlOutput */1 :
        return "UrlOutput(" + (stringify$1(v._0) + ")");
    case /* JumpToTabOutput */2 :
        return "JumpToTabOutput(" + (RenderOnHost__Notification__JumpToTabOutput$SmartcutsMacros.stringify(v._0) + ")");
    
  }
}

var JumpToTabOutput;

exports.TextOutput = TextOutput;
exports.UrlOutput = UrlOutput;
exports.JumpToTabOutput = JumpToTabOutput;
exports.t_encode = t_encode$3;
exports.t_decode = t_decode$3;
exports.stringify = stringify$2;
/* container Not a pure module */
